module.exports = __webpack_public_path__ + "img/public_cost.789c8981.png";